import { DdEventCategory, DdEventType } from '../types';
import { Logger } from './rumEvents';

export const logFanduelInfo = (message: string) =>
  console.log(`%c${message}`, 'color:rgb(0, 123, 255)');

export const logWBLaunchV2Info = (message: string) =>
  console.log(`%c FD-WBLv2 -> ${message}`, 'color:rgb(255, 140, 0)');

export enum NotifySuccessActionsNames {
  INIT_STARTED = '[GW][INIT] Client ready to receive events',
  INIT_SUCESSFULL = '[GW][INIT] Game params received and context initialized',
}

export const ddNotifyClientInitialization = () => {
  logFanduelInfo(NotifySuccessActionsNames.INIT_STARTED);

  Logger.logRumAction({
    name: NotifySuccessActionsNames.INIT_STARTED,
    useCase: DdEventCategory.Initialization,
    eventType: DdEventType.Success,
  });
};

export const ddNotifyContextIntializedAction = (
  payload: Record<string, unknown>,
) => {
  logFanduelInfo(NotifySuccessActionsNames.INIT_SUCESSFULL);

  Logger.logRumAction({
    name: NotifySuccessActionsNames.INIT_SUCESSFULL,
    useCase: DdEventCategory.Initialization,
    eventType: DdEventType.Success,
    context: {
      ...payload,
    },
  });
};
